import React, {useEffect, useState} from 'react';
import ErrorIcon from '../../Assets/SVG/ErrorIconDynamica';
import {isMobile} from 'react-device-detect';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import {buildUrlAndOpenSameWindow} from '../../../../../utilities/StringHelpers/StringHelpers';
import Config from '../../../../../Config';
import {stageEnums} from '../../Assets/VolteCheckVariables';

const ErrorScreen = (props) => {
  return (
    <>
      <div style={{margin: '36px 0 24px 0'}}>
        <ErrorIcon />
      </div>
      <div className='headBox'>
        <p className='heading'>
          משהו השתבש ולא הצלחנו
          <br />
          לבדוק את המכשיר שלך
        </p>
      </div>
      <div className='finishFooter'>
        <BtnSubmit
          text='מעוניין שיחזרו אליי'
          onclick={() => {
            props.setStage(stageEnums.callback);
          }}
        />
      </div>
    </>
  );
};

export default ErrorScreen;
